import { useEffect, useState } from "react";
import { Buton } from "@koclukpanel/ui";
import type { KendiKodlamam } from "@koclukpanel/contracts";
import { kendiKodlamam } from "./api";
import { DenemeKodlama, type DenemeKodlamaProps } from "./DenemeKodlama";

export function KodlamaAc(ozellikler: Omit<DenemeKodlamaProps, "baslangic">) {
  const [baslangic, setBaslangic] = useState<KendiKodlamam | null>(null);
  const [hata, setHata] = useState(false);
  const [deneme, setDeneme] = useState(0);
  useEffect(() => {
    let gecerli = true;
    setHata(false);
    // F-EXM-04 — yükleme hatası boş kodlama sayılmaz; mevcut cevaplar korunur.
    void kendiKodlamam(ozellikler.deneme.id).then(
      (veri) => {
        if (gecerli) setBaslangic(veri);
      },
      () => {
        if (gecerli) setHata(true);
      },
    );
    return () => {
      gecerli = false;
    };
  }, [ozellikler.deneme.id, deneme]);
  if (baslangic) return <DenemeKodlama {...ozellikler} baslangic={baslangic} />;
  return (
    <div>
      <p role={hata ? "alert" : "status"}>
        {hata
          ? "Kayıtlı cevaplarınız yüklenemedi. Lütfen yeniden deneyiniz."
          : "Kayıtlı cevaplarınız yükleniyor…"}
      </p>
      {hata && <Buton onClick={() => setDeneme((sayi) => sayi + 1)}>Yeniden dene</Buton>}
      <Buton onClick={ozellikler.onKapat}>Kapat</Buton>
    </div>
  );
}
